/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum TokenScope {

    PROJECT_INVITATION = 'PROJECT_INVITATION',

    UNREGISTERED_PROVIDER_CREATE_DATA = 'UNREGISTERED_PROVIDER_CREATE_DATA',

    PROVIDER_USER_INVITATION = 'PROVIDER_USER_INVITATION'
}

